import { Badge, Icon } from '@zenchef/ds-react'
import { HTMLStyledProps } from '@zenchef/styled-system/types'
import React from 'react'

import Subtitle from '@/components/redesign/common/Subtitle'

export default function HighlightedExperienceBadge({
  children,
  subtle,
  ...props
}: {
  children?: React.ReactNode
  subtle?: boolean
} & HTMLStyledProps<'span'>) {
  if (!children) {
    return (
      <Badge zIndex={1} icon outlined function='neutral' {...props}>
        <Icon name='chef-hat-solid' fontSize='{sizes.3xs}!' />
      </Badge>
    )
  }
  return (
    <Subtitle width='fit-content' pl='padding.0,5' gap='gap.2' {...props}>
      <HighlightedExperienceBadge subtle={subtle} />
      {children}
    </Subtitle>
  )
}
